import classNames from "classnames";
import React, { Component } from "react";
import DragSource from "react-dnd/lib/DragSource";

class AssetTileDND extends Component {
  constructor(props) {
    super(props);
  }

  handleTouchTap = () => {
    //this.props.onTap(this.props.asset);
  };

  render() {
    const { isDragging, connectDragSource, asset, selected, children } =
      this.props;

    return connectDragSource(
      <div
        className={classNames({
          dragging: isDragging,
          selected,
        })}
        onTouchTap={this.handleTouchTap}
      >
        {this.props.children}
      </div>
    );
  }
}

const AssetSource = {
  beginDrag(props) {
    console.log("beginDrag asset");
    window.scrollBy(0, 20, "smooth");

    return props.asset;
  },
};

const makeSource = DragSource(
  "ASSET_TYPE",
  AssetSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
);

export default makeSource(AssetTileDND);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetTileDND/index.js